module.exports = __webpack_public_path__ + "static/media/change-password-outline.430626d6.svg";